import MenuItem, { MenuItemLoading } from '../components/MenuItem';

import type { HeaderCollectionsItemT } from '..';

type HeaderCollectionsMobilePropsT = {
  menuList: HeaderCollectionsItemT[];
  isStatic?: boolean;
};

const HeaderCollectionsMobile = (props: HeaderCollectionsMobilePropsT) => {
  const { menuList = [], isStatic } = props;

  return (
    <div
      className={`HeaderCollections hide-scroll-mobile${
        isStatic ? ' HeaderCollections--static' : ''
      }`}
    >
      {menuList.length > 0 ? (
        menuList?.map((item, index) => (
          <div key={item.id}>
            <MenuItem
              icon={item.icon}
              link={item.link}
              title={item.title}
              isLast={index === menuList.length - 1}
              isRed={index === 0}
            />
          </div>
        ))
      ) : (
        <>
          {Array.from({ length: 5 }).map((_, index) => (
            <MenuItemLoading key={`loading-${index}`} />
          ))}
        </>
      )}
    </div>
  );
};

export default HeaderCollectionsMobile;
